import React, { Component, Fragment } from "react";
import { Select, Tabs, Form, Checkbox } from "antd";
import { inject, observer } from "mobx-react";
import co from "co";
import { IndexingServices } from "common/general";

const Option = Select.Option;
const TabPane = Tabs.TabPane;
const FormItem = Form.Item;

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},

	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class IndexerForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};

	render() {
		const tier = this.props.tier;
		let useIndexers = this.props.form.getFieldValue(`useIndexers`);

		let indexerPart = "";
		if (useIndexers) {
			indexerPart = (
				<FormItem label="Indexing Services">
					{this.props.form.getFieldDecorator(`indexers`, {
						rules: [
							{
								required: true,
								message: (
									<span>
										Because you ticked <b>Use Indexing Services</b>. You need to
										select indexing services to help index your links
									</span>
								)
							}
						]
					})(
						<Select
							style={{ width: 400 }}
							placeholder="Select indexing services"
                            mode="multiple"
                            disabled={!this.props.ui.editing}
						>
							{IndexingServices.map(service => {
								return (
									<Option key={service.name} id={service.name}>
										{service.text}
									</Option>
								);
							})}
						</Select>
					)}
				</FormItem>
			);
		}

		let indexingHelp = (
			<span>
				Using an indexing service may increase your chance of getting your links
				indexed by Google.{" "}
				<a href="#/options?tab=indexer" target="_blank">
					Click here
				</a>{" "}
				to configure indexing services
			</span>
		);
		return (
			<Fragment>
				<FormItem style={{ marginBottom: 10 }} extra={indexingHelp}>
					{this.props.form.getFieldDecorator(`useIndexers`, {
						valuePropName: "checked"
					})(
						<Checkbox disabled={!this.props.ui.editing}>
							<span>Use indexing service</span>
						</Checkbox>
					)}
				</FormItem>
				{indexerPart}
			</Fragment>
		);
	}
}

@inject("rootStore")
@observer
class IndexerTab extends Component {
	internalForms = [];

	mapPropsToFields = () => {
		const {
			rootStore: { projectStore }
		} = this.props;

		const stateForm = projectStore.stateForm;

		return {
			useIndexers: Form.createFormField(stateForm.useIndexers),
			indexers: stateForm.indexers.value
				? Form.createFormField({
						...stateForm.indexers,
						value: stateForm.indexers.value.slice()
				  })
				: Form.createFormField({
						value: []
				  })
		};
	};

	onFieldsChange = changedFields => {
		const {
			rootStore: { projectStore }
		} = this.props;
		projectStore.formChanged(changedFields);
	};

	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	render() {
		const {
			rootStore: { projectStore }
		} = this.props;
		const ui = projectStore.ui;

		if (ui.loadingProject) {
			return <Fragment />;
		}
        let fields = this.mapPropsToFields();        

		return (
			<IndexerForm
                fields={fields}
                ui={ui}
				onFieldsChange={this.onFieldsChange}
				wrappedComponentRef={internalForm => {
					if (internalForm != null) {
						this.internalForm = internalForm;
					}
				}}
			/>
		);
	}
}

export default IndexerTab;
